import joi from 'joi';
import { Location } from 'vue-router';
import router from '@/renderer/router/index';
import { IS_BROWSER, IS_DEV } from '@/common/constant';
import ipc from '@/renderer/scripts/utils/ipc';
import { IpcEvents } from '@/ipc-events';
// 在浏览器打开指定url
function openUrlInBrowser(url: string, target = '_blank'): void {
  if (IS_BROWSER) {
    window.open(url, target);
  } else {
    ipc.send(IpcEvents.ON_OPERATE_MAIN_LISTENER, {
      event: 'openUrl',
      params: { url },
    });
  }
}
/**
 *
 * @param params 跳转的链接，字符串为打开链接，对象为路由跳转
 * @param _type 跳转类型
 * @param size 适用于window.open打开的网页大小
 * @returns
 */
export function dispatchRouter(params: Location, _type?: string): Promise<void>;
export function dispatchRouter(params: string, _type?: 'newWindow' | 'location' | string, size?: string): void;
export function dispatchRouter(params: Location | string, _type?: string, size?: string) {
  if (typeof params === 'string') {
    // 只用于打开个窗口放视频的
    if (size && _type === 'newWindow' && size.length > 0) {
      window.open(params, _type, size);
    } else if (_type === 'location' || _type === '_self') {
      // 某些地方只需要替换href的
      window.location.href = params;
    } else {
      // 打开新链接的
      openUrlInBrowser(params, _type || '_blank');
    }
    return;
  }

  checkParams(params);
  const type = _type || IS_BROWSER ? 'push' : 'replace';
  return router[type](params).catch(() => {
    // console.log('wonder_log ~ changeRoute ~ err', err);
  });
}

// 验证参数合法性
function checkParams(params: Location) {
  const routerRules = {
    personalSpace: joi.object({
      name: joi.string().required(),
      query: joi.any().optional(),
      params: joi.object({
        guide: joi.string(),
      }),
    }),
    collaborationSpace: joi.object({
      name: joi.string().required(),
      query: joi.any().optional(),
      params: joi.object({
        guide: joi.string(),
      }),
    }),
    teamSpace: joi.object({
      name: joi.string().required(),
      query: joi.object({
        teamPath: joi.string().required(),
        spaceId: joi.string().required(),
        teamId: joi.string().required(),
        path: joi.string().allow(''),
        fromRoute: joi.string().optional(),
      }),
      params: joi.any().optional(),
    }),
    register: joi.object({
      name: joi.string().required(),
      query: joi.object({
        from: joi.string().required(),
        bind: joi.string().allow(''),
      }),
    }),
    spaceStatistics: joi.object({
      name: joi.string().required(),
      query: joi.any().optional(),
      params: joi.object({
        guide: joi.string(),
      }),
    }),
    search: joi.object({
      name: joi.string().required(),
      query: joi.object({
        keyword: joi.string().allow(''),
      }),
    }),
    share: joi.object({
      name: joi.string().required(),
      query: joi.any().optional(),
      params: joi.object({
        shareToken: joi.string(),
      }),
    }),
  };
  // @ts-ignore
  // 有些上面的rules没写的，说明是不传任何参数的，所以可以不用验证了
  if (!routerRules[params.name]) return;

  // @ts-ignore
  const { error } = routerRules[params.name].validate(params);
  if (error) {
    if (IS_DEV) {
      throw new Error(`${params.name} router invalid parameter`);
    }
  }
}
